import { Component, OnInit, OnDestroy, effect } from '@angular/core';
import { ReactiveFormsModule, FormGroup, FormBuilder } from '@angular/forms';
import { distinctUntilChanged } from 'rxjs'; 
import { map, debounceTime } from 'rxjs/operators';

import { DirectSessionLogicService } from '../../../../shared/direct-session-logic.service';
import { ItemFormat } from '../../../../shared/models/itemFormat.model';
import { GoogleService } from '../../../../shared/google.service';
import { uspsData } from '../../../../shared/models/uspsData';
import { standardizedAddress } from '../../../../shared/models/standardizedAddress';
import { environment } from '../../../../../environments/environment';
import { CustomerFormat } from '../../../../shared/models/customerFormat.model';


@Component({
  selector: 'app-form-contact-confirmation',
  template: `
  <section>
    <div>
        <div class="row flex">
          <h5 class="col-10">Your Personal Info</h5>
          <div class="col-2 edit-label" (click)="GoToEditPage()" > Edit <img src="assets/Icons/edit-pencil.svg" alt="edit" clickable></div>
        </div>

        <div class="row ">
          <div class="col-lg-6 col-md-12  ">
            <label for="firstName" class="form-label input-labels"><b>First Name</b>  {{firstName}}</label>
          </div>

          <div class="col-lg-6 col-md-12  ">
            <label for="lastName" class="form-label input-labels"><b>Last Name</b>  {{lastName}}</label>
          </div>
        </div>

        <div class="row ">
          <div class="col-lg-6 col-md-12  ">
            <label for="address" class="form-label input-labels"><b>Address</b>  {{address}}</label>
          </div>
              
          <div class="col-lg-6 col-md-12  ">
            <label for="address" class="form-label input-labels"><b>ZIP Code</b>  {{zipCode}}</label>
          </div>
        </div>

        <div class="row ">
          <div class="col-lg-6 col-md-12  ">
            <label for="address" class="form-label input-labels"><b>City</b>  {{city}}</label>
          </div>
              
          <div class="col-lg-6 col-md-12  ">
            <label for="address" class="form-label input-labels"><b>State</b>  {{state}}</label>
          </div>
        </div>

        <div class="row ">
          <div class="col-lg-6 col-md-12  ">
            <label for="address" class="form-label input-labels"><b>Phone Number</b>  {{phone}}</label>
          </div>
        </div>
              
        <div class="row ">
          <div class="col-lg-6 col-md-12  ">
            <label for="address" class="form-label input-labels"><b>Email</b>  {{email}}</label>
          </div>
        </div>
    </div>
    
  </section>
  `,
  styleUrls: ['./form-contact-confirmation.component.scss'],
  standalone: true,
  imports: [ 
    ReactiveFormsModule
  ]
})
export class FormContactInfoConfirmationComponent {
  
  contactForm: FormGroup = new FormGroup({});

  get selections(): ItemFormat[] {
    return this.directSessionLogic.cartItemsSignal();
  }

  firstName: string = '';
  lastName: string = '';
  email: string = '';
  phone: string = '';
  address: string = '';
  city: string = '';
  state: string = '';
  zipCode: string = '';
  country: string = '';

  isAddressVerified:boolean = false; // set using this.setAddressValidationStatus(bool)
  isAddressComplete:boolean = false; // 
  uspsData:uspsData | any = {};
  enteredAddress = {} as standardizedAddress;
  verifiedAddress = {} as standardizedAddress;


  companyName: string = "";
  contactPermissionMessage: string = "we may contact you if you click next";

  nameRegex: RegExp = /^[a-zA-Z\-]+$/;
  phoneRegex: RegExp = /^([0-9]{3})[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  zipCodeRegex: RegExp = /[0-9]{5}/;
  emailRegex: RegExp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/;

  //list of all valid two character state IDs

  constructor(
    public directSessionLogic: DirectSessionLogicService,
    private builder: FormBuilder,
    public googleService: GoogleService
  ) {
    this.escapeCheck();

    this.getSessionInfo();
    this.getConfigData();
  }

  //Add on exit function to save form data to session
  //ONLY if customer has a name and either (email or phone number)

  getSessionInfo() {
    let customer = this.directSessionLogic.customerSignal();

    if(customer.firstName != undefined || customer.firstName != null){
      this.firstName = customer.firstName;
      this.lastName = customer.lastName;
      this.email = customer.email;
      this.phone = this.parseOutPhoneNumber(customer.phoneNumber);
      this.address = customer.address;
      this.city = customer.city;
      this.state = customer.state;
      this.zipCode = customer.zip;
      this.country = customer.country;
    }
  }

  async getConfigData(){
    this.companyName = environment.CompanyInfo.CompanyName.toString();
    
    this.contactPermissionMessage = environment.LegalData.find( data => 
      data.legalRef == "contact"
      )?.legalText || "error getting contact permission message for $$company$$";

    this.contactPermissionMessage = this.contactPermissionMessage.replace(
      "$_$", this.companyName
    );
  }

  parseOutPhoneNumber(phone: string): string{
    // Remove non-numeric characters
    let parsedPhone = phone.replace(/[^0-9]/g, '');

    // Check if the length is 10 digits
    if (parsedPhone.length === 10) {
      // Format the phone number
      parsedPhone = `+1 (${parsedPhone.slice(0, 3)}) ${parsedPhone.slice(3, 6)}-${parsedPhone.slice(6)}`;
    }
    return parsedPhone;
  }


  GoToEditPage(){
    //have this section call the navigate to page function navControls
    let canMoveToEdit = this.directSessionLogic.changingStepSignal(0);

    if(canMoveToEdit){
      console.log("returning to conact page");
      this.directSessionLogic.unCompleteStepAfter(0);

      let navUrl = this.directSessionLogic.getStepAtIndexSignal(0).reference;
      this.directSessionLogic.redirectToStepSignal(navUrl);
    }
  }  


  escapeCheck(){
    if(this.directSessionLogic.planSelectedSignal().name === undefined || this.directSessionLogic.planSelectedSignal().name === null) {
      console.log("no plan selected, escaping to top level");
      this.directSessionLogic.escapeToTopLevelSignal();
    }else{
      console.log("plan selected, continuing");
      this.directSessionLogic.completeCurrentPage();
    }
  }
}


  

